<template>
  <div class="card p-4">
    <div class="col-12 d-md-flex justify-content-lg-between mb-3 clickable" @click.prevent="toggle">
      <h4><span class="badge badge-danger"><b>{{ showing ? "--":"+"}}</b></span> Formas de Pagamento</h4>
    </div>

    <div class="collapse show" id="collapse-payment">
      <div class="col-12 mb-3">
        <form class="row" @submit.prevent="">
          <div class="col-12 col-md-3 mb-3">
            <label>Forma de Pagamento</label>
            <select
              v-model="payment.type"
              class="form-control form-control-sm custom-select custom-select-sm"
              :class="{
                'is-invalid': payment.errors.has('type')
              }"
            >
              <option value="ccr">Cartão de Crédito</option>
              <option value="blt">Boleto</option>
              <option value="pix">PIX</option>
            </select>
            <has-error :form="payment" field="type" />
          </div>


          <div class="col-12 col-md-2 mb-3">
            <label>Parcelar até</label>
            <div class="input-group input-group-sm">
              <input
                type="number"
                v-model="payment.max_installments"
                :class="{
                  'is-invalid': payment.errors.has('max_installments')
                }"
                class="form-control form-control-sm"
                :disabled="payment.type !== 'ccr'"
              />
              <span class="input-group-append">
                <span class="input-group-text">Vezes</span>
              </span>
            </div>
            <has-error :form="payment" field="max_installments" />
          </div>

          <!-- <div class="col-12 col-md-3 mb-3">
            <label>Valor minimo da Parcela</label>
            <div class="input-group input-group-sm">
              <span class="input-group-append">
                <span class="input-group-text">R$</span>
              </span>
              <input
                type="number"
                class="form-control form-control-sm"
                v-model="payment.min_value"
                :class="{
                  'is-invalid': payment.errors.has('min_value')
                }"
                min="0"
                :disabled="payment.type === 'blt'"
              />
            </div>
            <has-error :form="payment" field="min_value" />
          </div> -->

          <div class="col-12 col-md-2 mb-3">
            <label>Sem Juros</label>
            <select
              class="form-control form-control-sm custom-select custom-select-sm"
              v-model="payment.interest_free"
              :class="{
                'is-invalid': payment.errors.has('interest_free')
              }"
            >
              <option :value="1">Sim</option>
              <option :value="0">Não</option>
            </select>
            <has-error :form="payment" field="interest_free" />
          </div>

          <div class="col-12 col-md-2 text-right">
            <label>&nbsp;</label>
            <button class="btn btn-sm btn-success form-control" @click="save">Salvar</button>
          </div>
        </form>
      </div>

      <div class="col-12">
        <table class="table table-responsive-md table-sm">
          <thead>
            <tr>
              <th>Tipo</th>
              <th>Max Parcelas</th>
              <th>Valor Minimo</th>
              <th>Juros?</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in payments" :key="item.id">
              <td v-if="item.type === 'ccr'">Cartão de Crédito</td>
              <td v-else-if="item.type === 'pix'">PIX</td>
              <td v-else>Boleto</td>

              <td>{{ item.max_installments }} Vezes</td>
              <td>{{ item.min_value | formatMoney }}</td>
              <td>{{ item.interest_free ? 'Sim' : 'Não' }}</td>
              <td>
                <button class="btn btn-sm btn-danger" @click="del( item.id )"><i class="fa fa-trash"></i></button>
                <button class="btn btn-sm btn-primary" @click="edit( item )"><i class="fa fa-edit"></i></button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from 'axios'
import Swal from 'sweetalert2'
import { Form, HasError } from 'vform'

export default {
  props: {
    course: {
      required: true
    }
  },
  watch: {
    course: {
      immediate: true,
      handler ( val, old ) {
        if ( val != undefined && val != old ) {
          this.load()
        }
      }
    }
  },
  data () {
    return {
      showing: true,
      payments: [],
      payment: new Form({
        id: undefined,
        course_id: undefined,
        type: undefined,
        max_installments: undefined,
        min_value: 0,
        interest_free: undefined,
        is_actived: true,
      })
    }
  },
  methods: {
    save: function () {
      this.payment.course_id = this.course
      this.payment.post('/teacher/course/payment')
        .then( res => {
          Swal.fire({
            icon: 'success',
            text: 'Informações atualizadas',
            title: 'Sucesso'
          })
          this.$emit('reloadQuota')
          this.load()
        })
        .catch( err => {
          console.error( err )
        })
        .then(() => {
          this.payment.id = undefined
          this.payment.reset()
        })
    },
    del: function ( id ) {
      Axios.delete('/teacher/course/payment', {
        data: {
          payment: id
        }
      })
        .then( res => {
          Swal.fire({
            icon: 'success',
            text: 'Informações deletada',
            title: 'Sucesso'
          })
          this.load()
        })
        .catch( err => {
          console.error( err )
        })
    },
    edit: function ( item ) {
      this.payment.fill( item )
    },
    load: function () {
      Axios.get(`/teacher/course/payment?course=${ this.course }`)
        .then( res => {
          this.payments = res.data
        })
        .catch( err => {
          console.error( err )
        })
    },
    toggle: function () {
      this.showing = !this.showing
      $("#collapse-payment").collapse('toggle')
    }
  }
}
</script>
